import { useAtomValue } from 'jotai'
import {
  errorAtom,
  isRetryPossibleAtom,
  isSuccessAtom,
} from '@/src/stores/route-machine/atoms'
import { cn } from '@/src/utils/styles'
import { RetryButton } from '../trade-overview/actions-buttons'

export default function OverviewFooter() {
  const error = useAtomValue(errorAtom)
  const isRetryPossible = useAtomValue(isRetryPossibleAtom)
  const isSuccess = useAtomValue(isSuccessAtom)

  return (
    <div
      className={cn('flex w-full pb-5 px-5 bg-foreground rounded-b-3xl', {
        'pt-5': !isSuccess,
      })}
    >
      {!!error && isRetryPossible && (
        <div className='animate-fade-in w-full'>
          <RetryButton />
        </div>
      )}
    </div>
  )
}

/**
 * Temporarily hide the price banner, here is the old layout:
 * {!error ? (
        <>
          {!isSuccess && (
            <ListRowButton className='gap-4 p-4 border border-border1 rounded-2xl w-full justify-between'>
              <ListRowSide className='flex-row gap-4 items-center'>
                <div className='flex items-center justify-center size-12 rounded-full bg-success'>
                  <Trophy
                    className='text-success-text'
                    width={24}
                    height={24}
                  />
                </div>
                <div className='flex flex-col text-left'>
                  <ListRowSideName className='text-sm'>
                    Always get the best price
                  </ListRowSideName>
                  <ListRowSideDescription className='text-sm'>
                    Learn how we select our routes
                  </ListRowSideDescription>
                </div>
              </ListRowSide>
              <Chevron
                width={24}
                height={24}
                className='text-tertiary -rotate-90'
              />
            </ListRowButton>
          )}
        </>
      ) : (
        <div className='animate-fade-in w-full'>
          <RetryButton />
        </div>
      )}
 */
